/** @format */
import {
  Button,
  ButtonSize,
  ButtonVariant,
} from "@roadflex/react-components-www";
import getConfig from "next/config";
import Image from "next/image";
import { useRouter } from "next/router";
import { useEffect, useRef, useState } from "react";

const { publicRuntimeConfig } = getConfig();
const { NEXT_PUBLIC_CDN_URL } = publicRuntimeConfig;
/* eslint-disable-next-line */

interface CallToActionProps {
  partner?: string;
}

export function CallToAction(props: CallToActionProps) {
  const router = useRouter();
  const { partner } = props;
  const goToSignupPage = (partnerName) => {
    if (partnerName) {
      router.push({
        pathname: "/signup",
        query: { partner: partnerName },
      });
    } else {
      router.push({
        pathname: "/signup",
      });
    }
  };
  const goToContactUsPage = (partnerName) => {
    if (partnerName) {
      router.push({
        pathname: "/contact-us",
        query: { partner: partnerName },
      });
    } else {
      router.push({
        pathname: "/contact-us",
      });
    }
  };
  const sectionRef = useRef<HTMLDivElement | null>(null);
  const [isVisible, setIsVisible] = useState(false);
  useEffect(() => {
    const handleScroll = () => {
      if (!sectionRef.current) return;

      const topPosition = sectionRef.current.getBoundingClientRect().top;
      const windowHeight = window.innerHeight;

      if (topPosition < windowHeight * 0.9) {
        setIsVisible(true);
      } else {
        setIsVisible(false);
      }
    };

    window.addEventListener("scroll", handleScroll);
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);

  let footerLine1 = "";
  let footerLine2 = "";
  let footerLine3 = "";

  if (
    router.pathname === "/" ||
    router.pathname.includes("/customer-stories") ||
    router.pathname === "/partners/konexial"
  ) {
    footerLine1 = "Ready To Learn More?";
    footerLine2 = "";
    footerLine3 =
      "Schedule a free demo with our knowledgeable Fleet Consultants to explore the RoadFlex Platform and benefits.";
  } else if (router.pathname === "/prefunded") {
    footerLine1 = "Empower your fleet";
    footerLine2 = "with RoadFlex";
    footerLine3 = "Get up and running in a few simple steps";
  } else if (router.pathname === "/fleetcard") {
    footerLine1 = "Make your fleet stronger";
    footerLine2 = "with RoadFlex today";
    footerLine3 = "Become a member today in a few easy steps";
  } else if (
    router.pathname === "/competition" ||
    router.pathname === "/savings"
  ) {
    footerLine1 = "Experience the difference.";
    footerLine2 = "Join RoadFlex today!";
    footerLine3 =
      "Contact us with any questions or to learn more about how RoadFlex can make your fleet stronger.";
  } else if (router.pathname === "/career") {
    footerLine1 = "Strengthen your fleet with";
    footerLine2 = "the power of RoadFlex";
    footerLine3 = "No personal or business credit checks.";
  } else if (router.pathname === "/rewards") {
    footerLine1 = "Empower your fleet";
    footerLine2 = "with RoadFlex";
    footerLine3 = "Get up and running in just a few simple steps.";
  } else if (
    router.pathname === "/partners/fleetup" ||
    router.pathname === "/partners/nalp" ||
    router.pathname === "/partners/npma" ||
    router.pathname === "/partners/linxup" ||
    router.pathname === "/partners/fleetsharp"
  ) {
    footerLine1 = "It only takes 3 min to apply!";
    footerLine2 = "";
    footerLine3 =
      "Get approved within 1 day. No credit score check. No contracts - cancel anytime.";
  } else if (router.pathname === "/partners/ejward") {
    footerLine1 = "Supercharge Your Fuel Management!";
    footerLine2 = "";
    footerLine3 =
      "Unparalleled fueling flexibility and convenience. One Card for all of your fuel and fleet expenses. Protect against fuel theft and fraud.";
  } else {
    footerLine1 = "Manage your fleet";
    footerLine2 = "expenses with RoadFlex";
    footerLine3 = "Become a member today in a few easy steps";
  }

  return (
    <>
      <div
        className={`relative w-full text-white bg-cover ${
          partner === "ejward"
            ? "bg-ejWardLightTealGreen"
            : "bg-subscriber-background"
        }`}
      >
        <div className="relative overflow-hidden">
          <div className="container relative flex flex-row items-center w-full py-6 my-6 md:py-20">
            <div
              className={`flex flex-col justify-center ${
                partner === "ejward" ? "md:w-1/2" : "w-full "
              }`}
            >
              <div className="text-xl font-semibold sm:text-3xl md:text-5xl">
                {footerLine1}
              </div>
              <div className="my-2 text-xl font-semibold sm:text-3xl md:text-5xl">
                {footerLine2}
              </div>
              <div className="sm:mt-8 max-w-[450px] text-lg">{footerLine3}</div>
              {!partner && (
                <div className="flex flex-row mt-12">
                  <span>
                    <Button
                      variant={ButtonVariant.White}
                      onClick={() => goToContactUsPage(partner)}
                      className="!px-4 sm:!px-8 font-medium"
                      size={ButtonSize.Large}
                    >
                      Schedule a Demo
                    </Button>
                  </span>
                  <span className="ml-4">
                    <Button
                      variant={ButtonVariant.GrayOutlineWhiteText}
                      onClick={() => goToSignupPage(null)}
                      className="!px-4 sm:!px-8 font-medium"
                      size={ButtonSize.Large}
                    >
                      Apply Now
                    </Button>
                  </span>
                </div>
              )}
              {partner && (
                <div className="flex flex-row mt-12">
                  <span className="">
                    <Button
                      variant={ButtonVariant.White}
                      onClick={() => goToContactUsPage(partner)}
                      className="!px-4 sm:!px-8 font-medium"
                      size={ButtonSize.Large}
                    >
                      Book a Demo
                    </Button>
                  </span>
                  <span className="ml-4">
                    <Button
                      variant={ButtonVariant.GrayOutlineWhiteText}
                      onClick={() => goToSignupPage(partner)}
                      className="!px-4 sm:!px-8 font-medium"
                      size={ButtonSize.Large}
                    >
                      Apply Now
                    </Button>
                  </span>
                </div>
              )}
            </div>
            <div
              className={`hidden w-full md:block  ${
                partner === "ejward"
                  ? "max-w-[1000px] absolute right-[0px] md:right-[-200px]"
                  : "relative max-w-[250px]"
              }`}
            >
              {/* <div className="bg-[#ffa500] h-[150px] w-[300px] -rotate-12 top-[30%] blur-3xl absolute"></div> */}
              <div
                className={`transition-all duration-700 ease-in-out transform ${
                  isVisible
                    ? "translate-x-0 opacity-100"
                    : "translate-x-60 opacity-0"
                }`}
                ref={sectionRef}
              >
                {partner === "ejward" ? (
                  <Image
                    className="p-0 m-0"
                    src={`${NEXT_PUBLIC_CDN_URL}/partners/images/ejward/ejward-card-footer.png`}
                    alt="RoadFlex Fuel Management"
                    width={514}
                    height={320}
                    layout="responsive"
                    objectFit="contain"
                  />
                ) : (
                  <Image
                    className="h-12 p-0 m-0"
                    src={`${NEXT_PUBLIC_CDN_URL}/common/footer/images/footer-logo-x.png`}
                    alt="RoadFlex Fuel Management"
                    width={300}
                    height={400}
                    layout="responsive"
                    objectFit="contain"
                  />
                )}
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}

export default CallToAction;
